import { render, staticRenderFns } from "./PhoenixHeaderSection.vue?vue&type=template&id=50aa940c"
import script from "./PhoenixHeaderSection.vue?vue&type=script&lang=js"
export * from "./PhoenixHeaderSection.vue?vue&type=script&lang=js"
import style0 from "./PhoenixHeaderSection.vue?vue&type=style&index=0&id=50aa940c&prod&module=%24s&lang=scss"




function injectStyles (context) {
  
  this["$s"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports